import { baseStates, baseMutations, baseActions, baseGetters } from '@/stores/base';

export const companySupplierBilling = {

    namespaced: true,

    state:
    {
        ...baseStates,

        activeRange: 'all',
    },

    mutations:
    {
        ...baseMutations,

        setActiveRange: (state, range) => {

            state.activeRange = range;
        },
    },

    actions:
    {
        ...baseActions,

        onSortRange: async ({ commit }, range = 'all') =>
        {
            commit('setActiveRange', range);
        },
    },

    getters:
    {
        ...baseGetters,

        activeRange: state => state.activeRange,
    },
};
